export default {"src":"/_next/static/media/discover_logo.svg.4007009e.svg","height":20,"width":121,"blurWidth":0,"blurHeight":0};